/* src/app/components/lead-details/documents/documents/documents.component.css */
/*# sourceMappingURL=documents.component-ZMHSCNBF.css.map */
